import { ServiceSelectionEnum } from '../../../../../../../core/enums/applications/service-selection-enum';
import { SubmitToEwaFormOption } from '../../shared/models/submit-to-ewa-form-option';

export class CoordinationIndustrialBusinessFormOptionConstants {
    static readonly useEwaSelectsFrequenciesFormOption: SubmitToEwaFormOption =
        {
            id: 1,
            service: ServiceSelectionEnum.SOLO,
            title: 'EWA to Select Frequencies',
            description:
                'I have completed the application in its entirety and attest to its accuracy and compliance with FCC rules. EWA is requested to conduct the frequency selection and coordination process and certify and submit the application to the FCC for license processing. EWA and any associated FCC <a class="text-blue-600 underline hover:text-blue-800" href="https://www.enterprisewireless.org/service-fees" target="_blank" rel="noopener noreferrer">fees apply</a>. (This is the Cevo <strong>"Solo"</strong> service.)',
        };
    static readonly useFrequenciesSelfSelectionFormOption: SubmitToEwaFormOption =
        {
            id: 2,
            service: ServiceSelectionEnum.PRO,
            title: 'I Wish to Select Frequencies (Optional)',
            description:
                'I have completed the application in its entirety and attest to its accuracy and compliance with FCC rules. Further, I wish to directly participate in the frequency selection process. Upon my completion of frequency selection, EWA is requested to coordinate, certify and submit the application to the FCC for license processing. EWA and any associated FCC <a class="text-blue-600 underline hover:text-blue-800" href="https://www.enterprisewireless.org/service-fees" target="_blank" rel="noopener noreferrer">fees apply</a>. (This is the Cevo <strong>"Pro"</strong> service.)',
        };

    static formOptions(): SubmitToEwaFormOption[] {
        return [
            this.useEwaSelectsFrequenciesFormOption,
            this.useFrequenciesSelfSelectionFormOption,
        ];
    }
}
